@if (beneficiary) {
  <div class="row full-height">
    <div class="col-12 col-lg-3">
      <app-beneficiary-summary [beneficiary]="beneficiary" page="beneficiaryRsjPage"></app-beneficiary-summary>
    </div>
    <div class="col-12 col-lg-9 border-start bg-white px-0">
      <ul class="nav-tabs nav-fill" ngbNav #nav="ngbNav" (navChange)="onNavChange($event)" [activeId]="activeTabId">
        <li [ngbNavItem]="'rsj-personaldata'">
          <a ngbNavLink><h5 class="text-secondary" id="rsjPersonalDataTitle">RSJ</h5></a>
        </li>
        <li [ngbNavItem]="'rsj-payment'">
          <a ngbNavLink><h5 class="text-secondary" id="rsjPaymentsTitle">Paiements</h5></a>
        </li>
        <li [ngbNavItem]="'rsj-instruction'">
          <a ngbNavLink><h5 class="text-secondary" id="instructionsTitle">Instructions</h5></a>
        </li>
        <li [ngbNavItem]="'rsj-document'">
          <a ngbNavLink><h5 class="text-secondary" id="rsjDocumentsTitle">Documents RSJ</h5></a>
        </li>
      </ul>
      <router-outlet></router-outlet>
    </div>
  </div>
}
